exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-transfer-panel {\r\n  width: 300px;\n}\n.el-transfer-panel__body {\r\n  height: 600px;\n}\n.el-transfer-panel__list.is-filterable {\r\n  height: 500px;\n}\r\n", ""]);

// exports
